import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#philosophy", label: "Philosophy" },
  { href: "#services", label: "Services" },
  { href: "#workshops", label: "Workshops" },
  { href: "#connect", label: "Connect" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FAF9F6]/75 border-b border-sage/30"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-6 lg:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center gap-3 group"
        >
          <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-forest/30">
            <span className="absolute inset-1.5 rounded-full bg-[#8A9A86]/30" />
            <span className="relative font-serif-display text-forest text-lg">a</span>
          </span>
          <span className="font-serif-display text-forest text-xl tracking-tight">
            Align <span className="text-sage">Wellness</span>
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-sm text-forest/75 hover:text-forest tracking-wide transition-colors duration-300"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:block">
          <a
            href="#connect"
            data-testid="navbar-cta"
            className="aw-btn-primary text-[11px]"
          >
            Book a Call
          </a>
        </div>

        <button
          type="button"
          data-testid="navbar-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex h-11 w-11 items-center justify-center rounded-full border border-forest/20 text-forest"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="md:hidden border-t border-sage/30 bg-[#FAF9F6]/95 backdrop-blur-xl"
        >
          <ul className="px-6 py-6 space-y-5">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                  className="block text-forest/80 text-base"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#connect"
                onClick={() => setOpen(false)}
                data-testid="navbar-mobile-cta"
                className="aw-btn-primary w-full"
              >
                Book a Call
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
